import {createContext, useEffect, useReducer, useState} from "react";
import moment from "moment";

moment.locale('ko')

export const SpaceContext = createContext()
export const SpaceHandlerContext = createContext();


function reducer(state, action) {

    switch(action.type) {
        case 'space':
            let updatedData = state.map(item => {
                if(item.key === action.type) {
                    return {...item, value: action.payload.val['stName']}
                }
                if(item.key === 'date') return {...item, value: null}
                return {...item}
            })
            return [...updatedData]

        case 'date':
            let updatedStates = state.map(item => item.key === action.type ? {...item, value: action.payload.val}: item)
            return [...updatedStates]

        case 'delDate':
            let delState = state.map(item => {
                if(item['id'] === 1) {
                    return {...item, value: null}
                }else {
                    return {...item}
                }
            })

            return [...delState]

        case 'delRoom':
            let delStates = state.map(item => {
                if(item['id'] === 0) {
                    return {...item, value: ''}
                }else {
                    return {...item}
                }
            })

            return [...delStates]

        default:
            return state;
    }

}


const initialState = [
    {
        id: 0,
        key: 'space',
        loading: false,
        value: '',
        order: 1,
    },
    {
        id: 1,
        key: 'date',
        loading: false,
        value: null,
        order: 2,
    },
]

const SpaceSetting = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const [step, setStep] = useState(1);
    const [isLoading, setIsLoading] = useState(true);

    const appDispatchHandler = (type, val, pattern) => {
        // console.log(type,val)
        dispatch({ type, payload: { val, pattern } })
    }

    const delDispatchHandler = (type) => {
        dispatch({ type })
    }

    const loadStart = () => {
        setIsLoading(true)
    }

    const loadFinish = () => {
        setIsLoading(false)
    }

    const nextHandler = () => {
        setStep(prev => prev + 1);
    }



    return (
        <SpaceContext.Provider value={[state, step, isLoading]}>
            <SpaceHandlerContext.Provider value={[appDispatchHandler,nextHandler, loadStart, loadFinish, delDispatchHandler]}>
                {children}
            </SpaceHandlerContext.Provider>
        </SpaceContext.Provider>
    )
}

export default SpaceSetting;